<template>
  <div id="app" style="font-size: 1em">
    <div v-if="errorMsg" class="error-tip">{{ errorMsg }}</div>
  </div>
</template>

<script>
import {isBrower, parseQueryParams, buildCallbackUrl, checkCallback, isSafeRedirect} from "./lib/util"
import config from './lib/config'

export default {
  name: 'app',
  data() {
    return {
      brower: '',
      page: "",
      hrefParams: {},
      query: {},
      cookies: "",
      cookie: '',
      errorMsg: ''
    }
  },
  mounted() {
    Log('浏览器信息', window.navigator.userAgent, __bl);
    __bl && __bl._lg && __bl._lg('pv', {
      page: location.href
    });
    __bl && __bl.api && __bl.api('浏览器信息', true, 200, 200, window.navigator.userAgent);
    //微信打开
    //query 自行解析（只解码一次、非法百分号编码不会抛异常），避免 js-url 解析异常导致页面挂载失败
    const query = parseQueryParams(location.href);
    this.hrefParams = {query};
    this.query = query;
    this.cookie = document.cookie;
    __bl && __bl.api && __bl.api('cookie信息', true, 200, 200, this.cookie);
    __bl && __bl.api && __bl.api('get信息', true, 200, 200, JSON.stringify(this.query));

    //校验必传参数 appid、plat、callback 是否缺失
    const requiredKeys = ['appid', 'plat', 'callback'];
    const missingKeys = requiredKeys.filter(key => !this.query[key]);
    if (missingKeys.length) {
      const msg = `缺少${missingKeys.join('、')}参数`;
      __bl && __bl.api && __bl.api('参数缺失', false, 400, 400, msg);
      this.errorMsg = msg;
      return;
    }

    //校验 callback 跳转目标是否在白名单内（协议 + 主机）
    const cbRes = checkCallback(this.query.callback);
    if (!cbRes.ok) {
      __bl && __bl.api && __bl.api('callback白名单校验失败', false, 400, 400, cbRes.msg);
      this.errorMsg = cbRes.msg;
      return;
    }

    if (isBrower("micromessenger")) {
      this.brower = 'weixin';
      this.weixinInit();
    } else if (isBrower('alipayclient')) {
      this.brower = 'alipay';
      this.alipayInit();
    } else {
      //非微信支付宝打开
    }
  },
  methods: {
    //解析并校验 callback，不合法时提示并返回 null
    getCallbackParams(p) {
      const callback = p && p.callback;
      const res = checkCallback(callback);
      if (!res.ok) {
        __bl && __bl.api && __bl.api('callback白名单校验失败', false, 400, 400, res.msg);
        this.errorMsg = res.msg;
        return null;
      }
      return res.params;
    },

    //跳转前的最后一道防线：协议 + 主机再校验一次
    doRedirect(url) {
      if (!isSafeRedirect(url)) {
        const msg = `重定向地址"${url}"不在白名单内`;
        __bl && __bl.api && __bl.api('重定向地址白名单校验失败', false, 400, 400, msg);
        this.errorMsg = msg;
        return;
      }
      console.log('重定向地址', url);
      location.href = url;
    },

    alipayInit() {
      const query = this.query;
      if (!query || !query.callback) {
        alert("get参数不能为空");
        return
      }
      const APPID = config.alipay_appid[location.hostname];
      let cookie = this.$cookies.get('alipayuserid_' + APPID);
      if (cookie) {
        cookie = cookie.split('_');
        let cbParams = this.getCallbackParams(query);
        if (!cbParams) {
          return;
        }
        let red = buildCallbackUrl(cbParams, {openid: cookie[0], next: cookie[1] || '', t: new Date().getTime()});
        this.clearCookies();
        this.doRedirect(red);
      } else {
        this.goOauth2();
      }
    },
    weixinInit() {
      const query = this.query;
      if (!query || !query.callback) {
        alert("get参数不能为空");
        return
      }

      let openid = this.$cookies.get(`openid_${query.appid}`);
      if (query.openid) {
        this.gotOpenid(query, query.openid);
      } else if (openid) {
        this.gotOpenid(query, openid);
      } else {
        this.goOauth2(query);
      }
    },

    gotOpenid(p, openid) {
      console.log('cb', p.callback);
      let cbParams = this.getCallbackParams(p);
      if (!cbParams) {
        return;
      }
      //this.clearCookies();
      let red = buildCallbackUrl(cbParams, {openid: openid, t: new Date().getTime()});
      this.doRedirect(red);
    },

    //http://test-wechat-repeater.hztywl.cn/wechat/plat/oauth/wxa49f90b4ff678ef2?url=https%3a%2f%2fwww.baidu.com&scope=snsapi_userinfo
    goOauth2(p) {
      const {hostname} = location;
      const APPID = config.alipay_appid[location.hostname];
      if (this.brower === 'weixin') {
        location.replace(`http://${(p.plat && p.plat === 'pro') ? "" : "test-"}wechat-repeater.diandianys.com/wechat/plat/oauth/${p.appid}?url=${encodeURIComponent(location.href)}&scope=snsapi_base`);//snsapi_base/snsapi_userinfo
      } else if (this.brower === 'alipay') {
        location.replace(config.alipay_oauth2[hostname] + '/alipay/oauth/' + APPID + '?scope=auth_user&url=' + encodeURIComponent(location.href));
      }
    },
    goBack(p, showRed = false) {
      let openid = this.$cookies.get(`openid_${p.appid}`);
      let cbParams = this.getCallbackParams(p);
      if (!cbParams) {
        return;
      }
      this.clearCookies();
      let red = buildCallbackUrl(cbParams, {openid: openid, t: new Date().getTime()});
      if (showRed) alert(red);
      this.doRedirect(red);
    },
    clearCookies() {
      this.$cookies.keys().forEach((res) => {
        console.log(res, this.$cookies.remove(res, '/', '.hztywl.cn'));
      })
    }
  },
  watch: {}
}
</script>

<style lang="scss">
#app {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
}
.error-tip {
  color: #f56c6c;
  font-size: 1.2em;
  padding: 20px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/App.vue